// Field mappings whose option values are canonical codes
// (US state codes, suffix abbreviations, etc.) that feed MISMO/LOS and must
// never be translated. Display text for these stays in US English shortform
// across all languages.
export const SENSITIVE_FIELD_MAPPINGS = new Set([
  "state__c",
  "candidoem__state__c",
  "suffix_b__c",
  "candidoem__suffix_b__c",
  "suffix_co__c",
  "candidoem__suffix_co__c",
  "bankruptcy_chapter_type_b__c",
  "candidoem__bankruptcy_chapter_type_b__c",
  "bankruptcy_chapter_type_co__c",
  "candidoem__bankruptcy_chapter_type_co__c",
  "borrower_payment_type__c",
  "candidoem__borrower_payment_type__c",
  "co_borrower_payment_type__c",
  "candidoem__co_borrower_payment_type__c",
]);

export const isSensitiveField = (fieldMapping) =>
  SENSITIVE_FIELD_MAPPINGS.has(fieldMapping);
